module.exports = __webpack_public_path__ + "img/objects-links-bg-3.88c3078.png";